import dom, { Fragment } from "jsx-render";
import {
    alertHTML,
    bodyRequest,
    DateFormat,
    getData,
    getElement,
    requestOptions,
    tryAsyncFetch,
} from "../../../helpers";
import moment from "moment";
import { marked } from "marked";

class ProfileModule extends HTMLElement {
    connectedCallback() {
        this.test();
        this.events();
    }

    test() {
        // console.log(this);
    }

    events() {
        const Form = getElement("form", this);
        Form.elements.question.focus();

        Form.elements.send.addEventListener("click", async (e) => {
            let target = Form.elements.send;
            if (Form.reportValidity()) {
                const CtnChat = getElement(".chat-detail", this);
                let txt = Form.elements.question.value;

                const row = (
                    <>
                        <div class="d-flex flex-row-reverse text-end">
                            <img
                                src={getData(target, "data-photo-user")}
                                alt="user"
                                class="rounded-circle thumb-md"
                            />
                            <div class="ms-1 chat-box w-100">
                                <div class="user-chat">
                                    <p class="fw-bold">
                                        {getData(target, "data-user-name") +
                                            " " +
                                            moment().format(
                                                DateFormat + " HH:mm:ss"
                                            )}
                                    </p>
                                    <p>{txt}</p>
                                </div>
                            </div>
                        </div>
                    </>
                );

                CtnChat.appendChild(row);

                const L = (
                    <>
                        <div
                            class="alert alert-primary w-100 loading"
                            role="alert"
                        >
                            <span
                                class="spinner-border spinner-border-sm"
                                aria-hidden="true"
                            ></span>
                            <span role="status">Pensado...</span>
                        </div>
                    </>
                );

                CtnChat.appendChild(L);

                bodyRequest.set("question", txt);

                if (Form.elements.file.files.length) {
                    bodyRequest.set("file", Form.elements.file.files[0]);
                }

                const Response = await tryAsyncFetch(
                    getData(target, "data-url"),
                    requestOptions
                );

                CtnChat.lastChild.remove();

                if (Response.error) {
                    alertHTML(Response.error);
                    return;
                }

                let responseHTML = marked.parse(
                    Response.candidates[0].content.parts[0].text
                ); // Convertir Markdown a HTML

                let rowIA = (
                    <>
                        <div class="d-flex">
                            <img
                                src={getData(target, "data-photo-ia")}
                                alt="user"
                                class="rounded-circle thumb-md"
                            />
                            <div class="me-1 chat-box w-100 reverse">
                                <div class="user-chat">
                                    <p class="fw-bold">
                                        I.A.{" "}
                                        {moment().format(
                                            DateFormat + " HH:mm:ss"
                                        )}
                                    </p>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: responseHTML,
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                );

                CtnChat.appendChild(rowIA);

                Form.elements.question.value = "";
                Form.elements.question.focus();
            }
        });
    }
}

window.customElements.define("profile-module", ProfileModule, {
    extends: "section",
});
